import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import SidebarToggleButton from "../../components/SidebarToggleButton";
import { useAuth } from "../../useAuth";
import { useTranslation } from "react-i18next";
import {
  BarsOutlined,

  AppstoreOutlined,
  LoginOutlined,
  ApartmentOutlined,
ArrowRightOutlined,
ArrowLeftOutlined,
  UserOutlined,
 
  ShopOutlined,
  UsergroupDeleteOutlined,
  SettingOutlined,
  PushpinOutlined,
  SyncOutlined,
  FileTextOutlined,
  ApiOutlined,
  SafetyOutlined,
  DollarOutlined,
  HistoryOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import { Button, Typography, Divider, Dropdown } from "antd";
import MenuItem from "../../components/MenuItem";
import i18n from "../../i18n";

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isSidebarMobileOpen, setisSidebarMobileOpen] = useState(false);

  const { role, logout, userName } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const MenuContent: React.FC = () => {
    // const [current, setCurrent] = useState('mail');

    return (
      <div className="dark-mode-sidebar bg-neo-primary flex flex-col justify-between h-full no-scrollbar overflow-y-scroll rounded-3xl py-8 shadow-xl">
        <div className="px-6">
          <div className="bg-neo-primary rounded-xl p-4 shadow-md">
            <Typography className="text-white font-poppins-700 text-center text-2xl">
              NeoPaas Admin
            </Typography>
            {import.meta.env.VITE_ENV_LABEL && (
              <Typography className="text-white/80 font-poppins-300 text-center text-xs mt-1">
                {import.meta.env.VITE_ENV_LABEL}
              </Typography>
            )}
          </div>
        </div>

        <div className="mt-12 px-6 flex flex-col gap-y-2">
          <Typography className="font-poppins-600 text-xs text-neo-primary/60 uppercase tracking-wider mb-2 px-3">
            {t("menu")}
          </Typography>

          <div className="menu-item-stagger">
            <MenuItem
              display={true}
              current={location.pathname}
              location={"/neopass-admin"}
              icon={<AppstoreOutlined />}
              title={t("dashboard")}
              to={() => {
                navigate("/neopass-admin");
                setisSidebarMobileOpen(false);
              }}
            />
          </div>

          {/* <div className="menu-item-stagger">
            <MenuItem
              display={true}
              icon={<ShopOutlined />}
              title={"Vendor Management"}
              current={location.pathname}
              location={"/neopass-admin/msps"}
              to={() => {
                navigate("/neopass-admin/msps");
                setisSidebarMobileOpen(false);
              }}
            />
          </div> */}

          <div className="menu-item-stagger">
            <MenuItem
              display={true}
              icon={<ApartmentOutlined />}
              title={"Brands & Models"}
              current={location.pathname}
              location={"/neopass-admin/brands"}
              to={() => {
                navigate("/neopass-admin/brands");
                setisSidebarMobileOpen(false);
              }}
            />
          </div>

          <div className="menu-item-stagger">
            <MenuItem
              display={true}
              icon={<UsergroupDeleteOutlined />}
              title={"Merchants"}
              current={location.pathname}
              location={"/neopass-admin/merchants"}
              to={() => {
                navigate("/neopass-admin/merchants");
                setisSidebarMobileOpen(false);
              }}
            />
          </div>

          <div className="menu-item-stagger">
            <MenuItem
              display={true}
              icon={<ApartmentOutlined />}
              title={"ECR Providers"}
              current={location.pathname}
              location={"/neopass-admin/ecr-providers"}
              to={() => {
                navigate("/neopass-admin/ecr-providers");
                setisSidebarMobileOpen(false);
              }}
            />
          </div>

          <div className="menu-item-stagger">
            <MenuItem
              display={true}
              icon={<BarsOutlined />}
              title={"Provider Mappings"}
              current={location.pathname}
              location={"/neopass-admin/provider-mappings"}
              to={() => {
                navigate("/neopass-admin/provider-mappings");
                setisSidebarMobileOpen(false);
              }}
            />
          </div>

          <div className="menu-item-stagger">
            <MenuItem
              display={true}
              icon={<UserOutlined />}
              title={"MSP Onboarding"}
              current={location.pathname}
              location={"/neopass-admin/msp-onboarding"}
              to={() => {
                navigate("/neopass-admin/msp-onboarding");
                setisSidebarMobileOpen(false);
              }}
            />
          </div>

          <div className="menu-item-stagger">
            <MenuItem
              display={true}
              icon={<SafetyOutlined />}
              title={"MSP Organizations"}
              current={location.pathname}
              location={"/neopass-admin/msp-organizations"}
              to={() => {
                navigate("/neopass-admin/msp-organizations");
                setisSidebarMobileOpen(false);
              }}
            />
          </div>

          <div className="menu-item-stagger">
            <MenuItem
              display={true}
              icon={<WarningOutlined />}
              title={"Terminal Ownership"}
              current={location.pathname}
              location={"/neopass-admin/terminal-ownership"}
              to={() => {
                navigate("/neopass-admin/terminal-ownership");
                setisSidebarMobileOpen(false);
              }}
            />
          </div>

          <div className="menu-item-stagger">
            <MenuItem
              display={true}
              icon={<DollarOutlined />}
              title={"Billing"}
              current={location.pathname}
              location={"/neopass-admin/billing"}
              to={() => {
                navigate("/neopass-admin/billing");
                setisSidebarMobileOpen(false);
              }}
            />
          </div>

          <div className="menu-item-stagger">
            <MenuItem
              display={true}
              icon={<HistoryOutlined />}
              title={"Audit Trail"}
              current={location.pathname}
              location={"/neopass-admin/audit-trail"}
              to={() => {
                navigate("/neopass-admin/audit-trail");
                setisSidebarMobileOpen(false);
              }}
            />
          </div>

          <div className="menu-item-stagger">
            <MenuItem
              display={true}
              icon={<PushpinOutlined />}
              title={"Districts"}
              current={location.pathname}
              location={"/neopass-admin/districts"}
              to={() => {
                navigate("/neopass-admin/districts");
                setisSidebarMobileOpen(false);
              }}
            />
          </div>

          <div className="menu-item-stagger">
            <MenuItem
              display={true}
              icon={<SettingOutlined />}
              title={"Settings"}
              current={location.pathname}
              location={"/neopass-admin/settings"}
              to={() => {
                navigate("/neopass-admin/settings");
                setisSidebarMobileOpen(false);
              }}
            />
          </div>

          <div className="menu-item-stagger">
            <MenuItem
              display={true}
              icon={<SyncOutlined />}
              title={"Sync Configuration"}
              current={location.pathname}
              location={"/neopass-admin/sync-configuration"}
              to={() => {
                navigate("/neopass-admin/sync-configuration");
                setisSidebarMobileOpen(false);
              }}
            />
          </div>

          <div className="menu-item-stagger">
            <MenuItem
              display={true}
              icon={<ApiOutlined />}
              title={"Terminal Comm Config"}
              current={location.pathname}
              location={"/neopass-admin/terminal-comm-config"}
              to={() => {
                navigate("/neopass-admin/terminal-comm-config");
                setisSidebarMobileOpen(false);
              }}
            />
          </div>

          <div className="menu-item-stagger">
            <MenuItem
              display={true}
              icon={<SafetyOutlined />}
              title={"Permission Owner Types"}
              current={location.pathname}
              location={"/neopass-admin/permission-owner-types"}
              to={() => {
                navigate("/neopass-admin/permission-owner-types");
                setisSidebarMobileOpen(false);
              }}
            />
          </div>

          {/* <div className="menu-item-stagger">
            <MenuItem
              display={true}
              icon={<FileTextOutlined />}
              title="Daily Report"
              current={location.pathname}
              location={"/neopass-admin/daily-report"}
              to={() => {
                navigate("/neopass-admin/daily-report");
                setisSidebarMobileOpen(false);
              }}
            />
          </div> */}
        </div>

        {/* <div className="mt-12 px-6  flex flex-col gap-y-3  ">
          <Typography className="font-poppins-500 text-xs">General</Typography>

          <MenuItem
             display={true}
            icon={<ControlOutlined />}
            title="Settings"
            to={() => {
              alert("Settings");
            }}
          />

          <MenuItem
             display={true}
            icon={<QuestionCircleOutlined />}
            title="Help & Support"
            to={() => {
              alert("Support");
            }}
          />
        </div> */}

        <div className="p-6">
          <Divider className="border-neo-matt/50" />

          <MenuItem
            display={true}
            icon={<LoginOutlined />}
            title={t("logout")}
            to={logout}
          />
        </div>
      </div>
    );
  };

  const toggleSidebar = () => {
    setIsSidebarOpen((prevState) => !prevState);
  };

  // const handleShowDialog = (status: "approved" | "declined" | "canceled") => {
  //   setStatus(status);
  //   setShowDialog(true);
  // };

  // useEffect(() => {
  //   if (role === "cashier") connect();
  // }, [connect, role]);

  useEffect(() => {}, [role, navigate]);

  return (
    <>
      <div className={`flex  min-h-screen dark-mode`}>
        {/* Desktop Sidebar */}

        <div
          className={`fixed inset-y-0 ${
            i18n.language == "en" ? "left-0" : "right-0"
          } w-64 p-3 px-1.5  transform transition-transform 
          duration-300 z-10 hidden lg:block
            
          ${
            isSidebarOpen
              ? `${
                  i18n.language == "en"
                    ? "translate-x-0"
                    : "translate-x-0"
                }`
              : `${
                  i18n.language == "en"
                    ? "-translate-x-full"
                    : "translate-x-full"
                }`
          }
            
          `}
        >
          <MenuContent />
        </div>

        {/* Mobile Sidebar Overlay */}
        {isSidebarMobileOpen && (
          <div 
            className="fixed inset-0 bg-black/50 z-40 lg:hidden"
            onClick={() => setisSidebarMobileOpen(false)}
          />
        )}

        {/* Mobile Sidebar */}
        <div
          className={`fixed inset-0 ${i18n.language=="en"?"left-0":"right-0"} w-full h-full p-3 px-1.5 transform transition-transform 
          duration-300 z-50 lg:hidden
            
          ${isSidebarMobileOpen ? "translate-x-0" : `${i18n.language=="en"?"-translate-x-full":"translate-x-full"}`}
            
          `}
        >
          <div className="flex flex-col h-full">
            <div className="flex p-3 justify-end w-full">
              <Button
                type="primary"
                icon={i18n.language=="en"?<ArrowLeftOutlined />:<ArrowRightOutlined />}
                onClick={() => setisSidebarMobileOpen(false)}
              />
            </div>
            <MenuContent />
          </div>
        </div>

        {/* main content */}
        <div
          className={`flex flex-col w-full min-w-0 overflow-x-hidden transition-all p-2 sm:p-3 gap-y-3 sm:gap-y-4 duration-300
          ${
            isSidebarOpen
              ? `${i18n.language == "en" ? "lg:ml-64" : "lg:mr-64"}`
              : ""
          }`}
        >
          {/* Top bar */}
          <div
            className={`flex ${
              i18n.language == "en" ? "flex-row" : "flex-row-reverse"
            } dark-mode-header justify-between p-3 sm:p-4 px-3 sm:px-6 gap-x-2 sm:gap-x-3 min-h-16 sm:min-h-24 items-center rounded-xl sm:rounded-2xl shadow-md`}
          >
            <div className="flex items-center gap-x-2 sm:gap-x-4">
              <Button
                className="text-white bg-neo-primary hover:bg-neo-primary/90 transition-colors lg:hidden"
                type="text"
                size="large"
                icon={<BarsOutlined />}
                onClick={() => setisSidebarMobileOpen(true)}
              />
              
              {/* Logo - shown when sidebar is closed on desktop */}
              {!isSidebarOpen && (
                <div className="hidden lg:flex flex-col items-start animate-fadeIn">
                  <Typography className="text-neo-primary font-poppins-700 text-xl leading-tight">
                    NeoPaas Admin
                  </Typography>
                  {import.meta.env.VITE_ENV_LABEL && (
                    <Typography className="text-neo-primary/60 font-poppins-400 text-xs mt-0.5">
                      {import.meta.env.VITE_ENV_LABEL}
                    </Typography>
                  )}
                </div>
              )}
            </div>

            <div className="flex items-center justify-end gap-x-2 sm:gap-x-3">
              <Dropdown
                menu={{
                  items: [
                    {
                      key: 'user-info',
                      label: (
                        <div className="px-2 py-2 min-w-[200px]">
                          <div className="flex items-center gap-x-3 mb-3 pb-3 border-b border-neo-matt/20">
                            <div className="w-12 h-12 rounded-full bg-neo-primary flex justify-center items-center shadow-md">
                              <UserOutlined className="text-white text-xl" />
                            </div>
                            <div className="flex flex-col">
                              <Typography className="font-poppins-600 text-sm text-gray-800">
                                {userName}
                              </Typography>
                              <Typography className="font-poppins-400 text-xs text-neo-primary/70 uppercase tracking-wide">
                                {role}
                              </Typography>
                            </div>
                          </div>
                          <div className="space-y-2">
                            <div className="flex items-center gap-x-2 text-xs text-gray-600">
                              <SettingOutlined className="text-neo-primary" />
                              <span className="font-poppins-400">{t("Admin Account")}</span>
                            </div>
                          </div>
                        </div>
                      ),
                      disabled: true,
                    },
                    {
                      type: 'divider',
                    },
                    {
                      key: 'logout',
                      label: (
                        <div className="flex items-center gap-x-2 text-red-600 hover:text-red-700">
                          <LoginOutlined />
                          <span className="font-poppins-500">{t("logout")}</span>
                        </div>
                      ),
                      onClick: () => logout(),
                    },
                  ],
                }}
                trigger={['click']}
                placement="bottomRight"
              >
                <div className="items-center flex gap-x-2 sm:gap-x-3 bg-neo-bg/30 rounded-lg sm:rounded-xl p-1.5 sm:p-2 pr-2 sm:pr-4 shadow-sm border border-neo-matt/20 hover:border-neo-primary/30 transition-all duration-200 cursor-pointer">
                  <div className="w-8 h-8 sm:w-12 sm:h-12 rounded-full bg-neo-primary flex justify-center items-center shadow-sm">
                    <UserOutlined className="text-white text-base sm:text-xl" />
                  </div>

                  <div className="hidden sm:flex flex-col justify-center">
                    <Typography className="font-poppins-600 text-sm text-gray-800">
                      {userName}
                    </Typography>
                    <Typography className="font-poppins-400 text-xs text-neo-primary/70 uppercase tracking-wide">
                      {role}
                    </Typography>
                  </div>
                </div>
              </Dropdown>
            </div>
          </div>

          <div className="hidden lg:block">
            <SidebarToggleButton isOpen={isSidebarOpen} onClick={toggleSidebar} />
          </div>

          <div className="py-3 px-2 sm:py-4 sm:px-4 lg:py-8 lg:px-8 flex flex-1 min-w-0 overflow-x-hidden bg-white rounded-xl sm:rounded-2xl shadow-sm border border-neo-matt/10">
            {children}
          </div>
        </div>
      </div>
    </>
  );
};

export { Layout };
